import axios from "axios";
const qs = require("qs");
import configUrl from '../../../config/configUrl'
// const BASE_URL = "https://iumsserver.logimis.com/" // 北京正式生产环境地址
// const BASE_URL = "https://iumsserverdev.logimis.com/";
// const BASE_URL = "https://iumsservertest.logimis.com/";
// const BASE_URL = "http://192.168.1.125:8980/";
 const BASE_URL = configUrl.ordinaryUrl;
// const BASE_URL = "http://192.168.1.185:8980/";
// const BASE_URL = "http://192.168.0.176:8980/"; // 赵松伟地址
// const BASE_URL = "http://shx.logimis.com/api/"; // 西安测试环境地址
// const BASE_URL ="http://api.test.apptest.asia:90/";

function post(url) {
  return function(params) {
    let baseInfo = localStorage.getItem("loginInfo") ? JSON.parse(localStorage.getItem("loginInfo")):'';
    if (baseInfo) {
      params.hospitalCode = baseInfo.hospitalCode; //医院
      params.unitCode = baseInfo.unitCode; //医管局
      params.userId = baseInfo.id;
      params.identity = baseInfo.identity;
    }
    return axios
      .post(BASE_URL + url, qs.stringify(params))
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw new Error(error);
      });
  };
}

function save(url) {
  return function(params) {
    let baseInfo = localStorage.getItem("loginInfo") ? JSON.parse(localStorage.getItem("loginInfo")):'';
    if (baseInfo) {
      params.hospitalCode = baseInfo.hospitalCode;
      params.unitCode = baseInfo.unitCode;
      params.userId = baseInfo.id;
      params.staffId = baseInfo.id;
      params.identity = baseInfo.identity;
    }
    let formdata = new FormData();
    for (var item in params) {
      formdata.append(item, params[item] || "");
    }
    return axios
      .post(BASE_URL + url, formdata)
      .then(res => {
        return res.data;
      })
      .catch(error => {
        throw new Error(error);
      });
  };
}
function setCookie(name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie =
    name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
}
  function delCookie(key) {
    var date = new Date();
    date.setTime(date.getTime() - 1);
    var delValue = getCookie(key);
    if (!!delValue) {
      document.cookie =
        key + "=" + delValue + ";expires=" + date.toGMTString();
    }
  }

export { post, save, setCookie, getCookie, delCookie };
                         